import { Avatar, Divider, Dropdown, Menu } from "antd";
import React, { useCallback } from "react";
import { useLang } from "../../hooks/useLang";
import AlertPopup from "../AlertPopup";
import {
  CaretDownOutlined,
  LoadingOutlined,
  LogoutOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { connect, useSelector } from "dva";
import avatar from "assets/images/avatar.png";
import { logout } from "../../models/auth";
import { countUnsentSales } from "../../services/offline/clearDeviceData";

function AvatarMenu({ logoutLoading, logout, displayName, role }) {
  const [lang] = useLang();
  const onLogout = useCallback(async () => {
    const unsent = await countUnsentSales();
    AlertPopup({
      title: lang("logout"),
      message: unsent
        ? `${unsent} sale(s) are not sent to the server yet and will be lost if you logout. Connect to the internet and wait for them to send first. Logout anyway?`
        : lang("logout_msg"),
      onOk: logout,
    });
  }, [logout, lang]);

  const shop = useSelector((state) => state.shop.data);

  return (
    <Dropdown
      overlay={
        <Menu>
          {role === "shop-owner" && (
            <>
              <Menu.Item
                key={"add-branch"}
                onClick={() => {
                  window.open("/register", "_blank");
                }}
                icon={<PlusOutlined />}
                style={{
                  textTransform: "capitalize",
                }}
                disabled={shop?.parent_shop_id ? true : false}
              >
                {lang("add branch")}
              </Menu.Item>

              <Divider style={{ margin: "8px 0" }} />
            </>
          )}
          <div style={{ padding: "8px 12px" }}>{displayName}</div>
          <Menu.Item
            key={"logout"}
            disabled={logoutLoading}
            onClick={onLogout}
            icon={logoutLoading ? <LoadingOutlined /> : <LogoutOutlined />}
            style={{ textTransform: "capitalize" }}
          >
            {lang("logout")}
          </Menu.Item>
        </Menu>
      }
      trigger={["click"]}
    >
      <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
        <Avatar size="small" title={displayName} src={avatar} />
        <CaretDownOutlined style={{ marginLeft: 2 }} />
      </div>
    </Dropdown>
  );
}

export default connect(
  ({ auth }) => ({
    logoutLoading: auth.loading.logout,
    displayName: auth.user?.email,
    role: auth.user?.role,
  }),
  {
    logout,
  },
)(AvatarMenu);
